import { Button, useDisclosure } from "@chakra-ui/react";
import React from "react";
import { FiTrash2 } from "react-icons/fi";
import { RemoveBillingOwnerModal } from "../../../components/organisms/accounts/RemoveBillingOwnerModal";

export const RemoveBillingOwnerButton = ({
  billingOwnerId,
  accountId,
}: {
  billingOwnerId: string;
  accountId: string;
}) => {
  const disclosure = useDisclosure();

  return (
    <>
      <Button
        size="sm"
        variant="ghost"
        colorScheme="red"
        onClick={disclosure.onOpen}
        leftIcon={<FiTrash2 />}
      >
        Remove billing owner
      </Button>
      {disclosure.isOpen && (
        <RemoveBillingOwnerModal
          accountId={accountId}
          billingOwnerId={billingOwnerId}
          disclosure={disclosure}
        />
      )}
    </>
  );
};
